import script from "./RatingMarksHistory.vue?vue&type=script&setup=true&lang=ts"
export * from "./RatingMarksHistory.vue?vue&type=script&setup=true&lang=ts"

import "./RatingMarksHistory.vue?vue&type=style&index=0&id=43b1809a&scoped=true&lang=scss"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-43b1809a"]])

export default __exports__